export default __webpack_public_path__ + "static/media/coin-icon-sprite.fa406ba2.svg";